import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Text } from "@pentabd/ui";

import { TRANSFER_STATUS } from "@constants/status.hrm";
import {
  INTERCHANGE_TRANSFER,
  InterchangeTransferDetailsFormDataType,
} from "@validations/HRM//interchangeTransfer/interchangeTransferValidation";
import { FileRowUnique } from "@components/FileRowUnique";

const { INITIATED } = TRANSFER_STATUS;
const {
  SOURCE_EMPLOYEE_ASSET_DOCS,
  SOURCE_EMPLOYEE_TRANSFER_DOCS,
  SOURCE_EMPLOYEE_JOINING_LETTER_DOCS,
  SOURCE_EMPLOYEE_NOC_DOCS,
  SOURCE_EMPLOYEE_SUPPORTING_DOCS,
} = INTERCHANGE_TRANSFER;

interface SupportingDocsProps {
  status?: string;
  isDisabled: boolean;
  canModifyAllTransfer: boolean;
  canModifyOwnTransfer: boolean;
}

export const SupportingDocs = ({ status }: SupportingDocsProps) => {
  const { t } = useTranslation();

  const {
    register,
    control,
    setValue,
    formState: { errors },
  } = useFormContext<InterchangeTransferDetailsFormDataType>();

  const isInitiated = status?.toUpperCase() === INITIATED;

  useEffect(() => {
    if (status) setValue("status", status);
  }, [status]);

  return (
    <>
      <Text
        weight="semibold"
        size="lg"
        color="dark"
        className="mb-8 pb-8 d-block border-bottom"
      >
        {t("INTERCHANGE_TRANSFER.SUPPORTING_DOCS.HEADER")}
      </Text>
      <div className="d-flex flex-column gap-8 pb-8">
        <FileRowUnique
          label="INTERCHANGE_TRANSFER.SUPPORTING_DOCS.TRANSFER_DOCUMENTS"
          name={SOURCE_EMPLOYEE_TRANSFER_DOCS}
          control={control}
          setValue={setValue}
          register={register}
          error={errors}
          required
          disabled={!isInitiated}
          fileDetails={["documentName", "date", "remarks", "memorialNo"]}
          isSingle
        />
        <FileRowUnique
          label="INTERCHANGE_TRANSFER.SUPPORTING_DOCS.ASSET_HANDOVER"
          name={SOURCE_EMPLOYEE_ASSET_DOCS}
          control={control}
          setValue={setValue}
          register={register}
          error={errors}
          disabled={!isInitiated}
          fileDetails={["documentName", "date", "remarks", "memorialNo"]}
          isSingle
        />
        <FileRowUnique
          label="INTERCHANGE_TRANSFER.SUPPORTING_DOCS.SUPPORTING_DOCS"
          name={SOURCE_EMPLOYEE_SUPPORTING_DOCS}
          control={control}
          setValue={setValue}
          register={register}
          error={errors}
          disabled={!isInitiated}
          fileDetails={["documentName", "date", "remarks", "memorialNo"]}
          isSingle
        />

        <FileRowUnique
          label="INTERCHANGE_TRANSFER.SUPPORTING_DOCS.NOC"
          name={SOURCE_EMPLOYEE_NOC_DOCS}
          control={control}
          setValue={setValue}
          register={register}
          error={errors}
          required
          disabled={!isInitiated}
          fileDetails={["documentName", "date", "remarks", "memorialNo"]}
          isSingle
        />

        <FileRowUnique
          label="INTERCHANGE_TRANSFER.SUPPORTING_DOCS.JOINING_LETTER"
          name={SOURCE_EMPLOYEE_JOINING_LETTER_DOCS}
          control={control}
          setValue={setValue}
          register={register}
          error={errors}
          required
          disabled={!isInitiated}
          fileDetails={["documentName", "date", "remarks", "memorialNo"]}
          isSingle
        />
      </div>
    </>
  );
};
